// Vrais avis Google — DS Serrurier / DS Serrurier Urgence
// NOTE_MOYENNE / NB_AVIS reflètent la fiche Google Business Profile dans son
// ensemble (34 avis, 5.0/5 relevés le 19/10/2026) — volontairement
// découplés de AVIS.length, qui n'affiche qu'une sélection d'avis avec texte.
// Ces chiffres évoluent avec le temps : à reconfirmer avant toute mise à jour.

export const AVIS = [
  {
    auteur: "Serge Dinguerie",
    note: 5,
    date: "Il y a 6 jours",
    texte: "Il m'a dépanné à 2:30 du matin au top.",
    source: "Google",
  },
  {
    auteur: "Samir Ghezal",
    note: 5,
    date: "Il y a une semaine",
    texte: "Top des top vraiment bon travail, meilleur prix avec précision et au top vraiment. Je vous le recommande.",
    source: "Google",
    complement: "Visité en juin",
  },
  {
    auteur: "Jules David",
    note: 5,
    date: "Il y a 2 semaines",
    texte:
      "Excellent serrurier à Puteaux. Intervention très rapide pour une ouverture de porte claquée. Professionnel, honnête et soigneux, sans dégâts sur la serrure. Prix clair annoncé à l'avance. Je recommande fortement DS Serrurier Urgence.",
    source: "Google",
  },
  {
    auteur: "YONATHAN Tchitchiama",
    note: 5,
    date: "Il y a 3 semaines",
    texte: "Intervention rapide et bon rapport qualité-prix. Je recommande.",
    source: "Google",
  },
  {
    auteur: "Cedric Richard",
    note: 5,
    date: "Il y a un mois",
    texte:
      "Ouverture de porte en urgence à Montrouge. Tarif correct annoncé avant l'intervention, explications claires sur le travail effectué.",
    source: "Google",
  },
  {
    auteur: "Moetez",
    note: 5,
    date: "Il y a un mois",
    texte:
      "Ouverture d'un Airbnb à 4h du matin : rapidité et professionnalisme au rendez-vous, même en pleine nuit.",
    source: "Google",
  },
];

export const NOTE_MOYENNE = 5.0;
export const NB_AVIS = 34;
